import { Breadcrumb } from 'antd'
import React from 'react'
import ContactTabs from './ContactTabs'

const Contact: React.FC = () => {
  const [breadcrumb, setBreadcrumb] = React.useState("Banner")
  return (
    <div className='mb-6'>
      <h1 className='text-xl sm:text-3xl font-semibold sm:mb-1' >Contact</h1>
      <div className='mb-4'>
        <Breadcrumb
          separator='>'
          items={[{ title: "Contact" }, { title: breadcrumb }]}
        />
      </div>
      <ContactTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  )
}

export default Contact